*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  --wui-input-clear-color: var(--wui-color-text-tertiary, rgb(27 27 27 / 0.35));
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

.wui-input-inner {
  position: relative;

  display: flex;
  gap: 8px;
  align-items: center;

  box-sizing: border-box;
  width: var(--wui-input-width, 200px);
  min-width: var(--wui-control-size, 40px);
  height: var(--wui-control-size, 40px);
  padding: 0 12px;
  border-radius: calc(infinity * 1px);

  transition:
    border-color var(--wui-duration-focus, 200ms),
    box-shadow var(--wui-duration-focus, 200ms);
}

:host([full]) {
  display: block;
}

:host([full]) .wui-input-inner {
  width: 100%;
}

/* ===== Borderless ===== */

:host([borderless]) .wui-input-inner {
  padding: 0;
  border: none;

  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
}

:host([focused]) .wui-input-inner {
  --wui-internal-glass-focus-ring:
    inset 0 0 0 1px var(--wui-color-accent, #08f),
    0 0 0 var(--wui-focus-ring-width, 3px) var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
}

:host([borderless][focused]) .wui-input-inner {
  border-color: transparent;

  /* borderless 移除了背景和玻璃阴影，但仍必须保留可感知的键盘/输入焦点边界 */
  outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
  outline-offset: 2px;
}

/* ===== Input ===== */

input {
  flex: 1;

  min-width: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;

  /* 表单控件不继承字体；显式继承以对齐宿主排版，避免 UA 默认字体差异 */
  font: inherit;
  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text, #1b1b1b);

  background: transparent;
  outline: none;

  &::placeholder {
    color: var(--wui-color-text-secondary, #6a6a6a);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
}

/* ===== Prefix / Suffix ===== */

slot {
  display: flex;
  flex-shrink: 0;
  align-items: center;

  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text-secondary, #6a6a6a);
}

/* slot 无 slotted 内容时折叠 */
slot.empty {
  display: none;
}

/* ===== Clear button ===== */

/* 复用 web-ui-button icon ghost：仅覆盖颜色为 faint，保持弱意图清除图标观感；
   负 margin-left 抵消容器 8px flex gap，让清除按钮紧贴输入文本 */
.wui-input-inner web-ui-button[variant='ghost'] {
  --wui-button-color: var(--wui-input-clear-color);
  margin-left: -8px;
}

/* ===== Disabled ===== */
